import { Component, Input } from '@angular/core';
import { PipesModule } from '../../pipes/pipes.module';
import { OrderStatusEnum } from '../../enums/orderStatus.enum';

@Component({
	selector: 'app-purchase-label',
	standalone: true,
	imports: [
		PipesModule
	],
	templateUrl: './purchase-label.component.html',
	styleUrl: './purchase-label.component.scss'
})
export class PurchaseLabelComponent {

	@Input() type: OrderStatusEnum;
	OrderStatus = OrderStatusEnum;

}
